'use client';

import classes from '@/components/calculator/CalculatorBase.module.scss';
import InfoIconModal from '@/components/infoIcon/InfoIconModal';
import { RichText } from '@/components/richText/RichText';
import { hasContent } from '@/helper/RichText';
import type { GlobalProjectSettingsStoryblok } from '@/types/component-types-sb';
import type { TFunction } from 'i18next';
import type { ReactNode } from 'react';

export const CALCULATOR_HT_FIELD_LABEL = 'Jahresverbrauch Hochtarif';
export const CALCULATOR_NT_FIELD_LABEL = 'Jahresverbrauch Niedertarif';

export type CalculatorConsumptionFieldVariant = 'ht' | 'nt' | 'standard';

export function getCalculatorConsumptionFieldLabel(variant: CalculatorConsumptionFieldVariant, t: TFunction): string {
  if (variant === 'ht') {
    return t(CALCULATOR_HT_FIELD_LABEL);
  }
  if (variant === 'nt') {
    return t(CALCULATOR_NT_FIELD_LABEL);
  }
  return t('Jahresverbrauch');
}

export function getCalculatorConsumptionAriaLabel(t: TFunction): string {
  return t('Kilowattstunde');
}

export function buildConsumptionEndAdornment(
  variant: CalculatorConsumptionFieldVariant,
  settings: GlobalProjectSettingsStoryblok | null | undefined,
  t: TFunction
): ReactNode {
  const unit = t('kWh');

  if (variant === 'ht' && hasContent(settings?.ht_info_text)) {
    return (
      <span className={classes.consumptionEndAdornment}>
        <span aria-hidden={true}>{unit}</span>
        <InfoIconModal headline={settings?.ht_info_headline} trackingLabel={CALCULATOR_HT_FIELD_LABEL}>
          <RichText text={settings?.ht_info_text} />
        </InfoIconModal>
      </span>
    );
  }

  if (variant === 'nt' && hasContent(settings?.nt_info_text)) {
    return (
      <span className={classes.consumptionEndAdornment}>
        <span aria-hidden={true}>{unit}</span>
        <InfoIconModal headline={settings?.nt_info_headline} trackingLabel={CALCULATOR_NT_FIELD_LABEL}>
          <RichText text={settings?.nt_info_text} />
        </InfoIconModal>
      </span>
    );
  }

  if (variant === 'ht' || variant === 'nt') {
    return <span aria-hidden={true}>{unit}</span>;
  }

  return <span aria-hidden={true}>{unit}</span>;
}
